import { type VariantProps } from 'class-variance-authority';
import { LuLogOut } from 'react-icons/lu';

import { GlobalAccount, GUID } from '@ndvr/customer-api';

import { Button, buttonVariants } from '@/components/ui/button';
import { useAdvisorLogin } from 'views/household/household-queries';

interface AdvisorLoginButtonProps {
    globalAccountGUID: GUID<GlobalAccount>;
    redirect: string;
    className?: string;
    size?: 'icon' | 'normal';
    variant?: VariantProps<typeof buttonVariants>['variant'];
}

export const AdvisorLoginButton = ({
    globalAccountGUID,
    redirect,
    className,
    size = 'normal',
    variant = 'ghost2',
}: AdvisorLoginButtonProps) => {
    const advisorLoginMutation = useAdvisorLogin();

    return (
        <Button
            onClick={() => advisorLoginMutation.mutate({ householdGUID: globalAccountGUID, redirect })}
            disabled={advisorLoginMutation.isPending}
            aria-label="Open in client portal"
            title="Open in client portal"
            className={className}
            variant={variant}
            size={size === 'icon' ? 'icon' : 'sm'}
        >
            {size === 'icon' ? <LuLogOut /> : 'Open Client Portal'}
        </Button>
    );
};
